import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["contenteditable", "data-placeholder", "spellcheck"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_resize = _resolveDirective("resize")

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    ref: "textarea",
    class: _normalizeClass(["contenteditable-textarea", {empty: !_ctx.value, disabled: $props.editorDisabled}]),
    contenteditable: $options.editable,
    "data-placeholder": $props.placeholder,
    spellcheck: $props.spellcheck,
    style: _normalizeStyle($options.style_vars),
    onPaste: _cache[0] || (_cache[0] = (...args) => ($options.onPaste && $options.onPaste(...args))),
    onBlur: _cache[1] || (_cache[1] = $event => (_ctx.$emit('blur', $event))),
    onInput: _cache[2] || (_cache[2] = (...args) => ($options.onInput && $options.onInput(...args))),
    onKeydown: _cache[3] || (_cache[3] = (...args) => ($options.onKeydown && $options.onKeydown(...args))),
    onKeyup: _cache[4] || (_cache[4] = (...args) => ($options.onKeyup && $options.onKeyup(...args)))
  }, null, 46 /* CLASS, STYLE, PROPS, NEED_HYDRATION */, _hoisted_1)), [
    [_directive_resize, $options.onResize]
  ])
}